import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 512 512"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M433.38 197.4c-39.59-16.4-81.67-9.08-109.84 19.09l-36.86 36.83-38.82-36.36-23.46 25.05 37.99 35.58-39.86 39.82 24.25 24.28 40.66-40.63 44.26 41.45 23.46-25.05-43.43-40.67 36.06-36.03c21.73-21.72 51.67-20.27 72.45-11.66 29.96 12.41 49.32 40.61 49.32 71.85 0 46.37-37.73 84.1-84.1 84.1H196.04v34.32h189.42c65.29 0 118.42-53.12 118.42-118.41 0-45.17-27.68-85.81-70.5-103.55Z",
  style: {"fill":"#fed124"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M211.98 283.51H97.14v34.32h72.04c-10.95 22.38-34.08 37.61-60.05 37.61-36.81 0-66.76-29.95-66.76-66.76s29.95-66.76 66.76-66.76c3.47 0 6.96.27 10.35.8l23.19 3.6-3.6-23.19c-.53-3.39-.79-6.88-.79-10.35 0-36.81 29.95-66.76 66.76-66.76s66.76 29.95 66.76 66.76h34.32c0-55.73-45.34-101.07-101.07-101.07s-98.31 42.63-100.95 96.03c-53.4 2.64-96.03 46.91-96.03 100.95s45.34 101.07 101.07 101.07c49.97 0 92.98-37.25 100.05-86.66l2.8-19.59Z",
  style: {"fill":"#fff"}
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }